import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Home';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import UsersList from './pages/UsersList';
import CustomersList from './pages/CustomersList';
import CustomerForm from './pages/CustomerForm';
import CustomerView from './pages/CustomerView';
import TwoFactorSetup from './pages/TwoFactorSetup';
import TwoFactorVerify from './pages/TwoFactorVerify';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <div className="container-fluid mt-4 px-4">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/2fa/setup" element={<TwoFactorSetup />} />
          <Route path="/2fa/verify" element={<TwoFactorVerify />} />
          
          {/* Protected routes - require authentication */}
          <Route 
            path="/users" 
            element={
              <PrivateRoute>
                <UsersList />
              </PrivateRoute>
            } 
          />
          
          <Route 
            path="/customers" 
            element={
              <PrivateRoute>
                <CustomersList />
              </PrivateRoute>
            } 
          />
          
          {/* <Route 
            path="/customers/new" 
            element={
              <PrivateRoute>
                <CustomerForm />
              </PrivateRoute>
            } 
          /> */}
          
          <Route 
            path="/customers/:id" 
            element={
              <PrivateRoute>
                <CustomerView />
              </PrivateRoute>
            } 
          />
          
          {/* <Route
            path="/customers/:id/edit"
            element={
              <PrivateRoute>
                <CustomerForm />
              </PrivateRoute>
            }
          /> */}
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
